var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesigningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6451 8.28874C27.1474 7.91341 27.0883 7.13091 26.6451 6.68733L21.2951 1.33269C20.8519 0.889104 20.1383 0.889104 19.6951 1.33269L11.0183 10.0019L2.35315 18.6593C1.906 21.4357 1.44716 24.2237 1 27L9.3022 25.6144C13.7905 21.1223 15.9114 19.0076 18.0521 16.8731C20.1927 14.7386 22.2981 12.6395 26.6451 8.28874Z",
    stroke: "white",
    strokeMiterlimit: 6.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8131 10.5159L23.7183 10.6107C23.6189 10.7101 23.4578 10.7101 23.3584 10.6107L17.3596 4.6118C17.2602 4.51242 17.2602 4.35129 17.3596 4.25191L17.4544 4.15707C17.5538 4.05768 17.7149 4.05769 17.8143 4.15707L23.8131 10.156C23.9125 10.2554 23.9125 10.4165 23.8131 10.5159Z",
    fill: "black",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51986 26.4869L1.60776 24.1739L3.83286 26.4294L1.51986 26.4869Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73209 24.5081L9.63725 24.6029C9.53787 24.7023 9.37674 24.7023 9.27736 24.6029L3.2785 18.604C3.17912 18.5046 3.17912 18.3435 3.2785 18.2441L3.37334 18.1493C3.47272 18.0499 3.63385 18.0499 3.73323 18.1493L9.73209 24.1482C9.83147 24.2476 9.83147 24.4087 9.73209 24.5081Z",
    fill: "black",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesigningIcon);
export default __webpack_public_path__ + "static/media/DesigningIcon.a91f312775244b6a4474fbb5bdc11ea7.svg";
export { ForwardRef as ReactComponent };